const state = {
    loading: false
}

const mutations = {
    show(state, data) {
        //对state对象中添加一个age成员
        // Vue.set(state, "age", 15)
        //刚刚添加的age成员删除
        // Vue.delete(state, 'age')
        // console.log(arguments)
        state.loading = true
    },
    hide(state) {
        state.loading = false
    }
}

const actions = {
    hideLoading(context) {
        context.commit('hide')
    },
}

const getters = {
    showInfo(state, getters) {
        return `当前：${state.loading}`;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}